module.exports = __webpack_public_path__ + "img/listen-on-spotify.897f3c5d.png";